import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { PRINT_ACCESS } from "../../_contstants/common";
import {
  checkAcessRights,
  formatIndianNumberForQty,
} from "../../_helper/helper";
import { Button } from "@progress/kendo-react-buttons";
import { getExportSalesOrderByPONO } from "../exportsalesorder/services/exporSalesOrder.services";
import moment from "moment";

const ExportPackingPrint: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const pono = params?.pono;
  const isPrintAccess = checkAcessRights("/exportpacking", PRINT_ACCESS);

  const loading = useAppSelector((state) => state.exportsalesorder.loading);
  const ExportSalesOrderDetailByPONO = useAppSelector(
    (state) => state.exportsalesorder.ExportSalesOrderDetailByPONO
  );

  useEffect(() => {
    if (pono) {
      const handleDriverVisitPrint = async () => {
        const res = await dispatch(getExportSalesOrderByPONO(pono));
        if (res.meta.requestStatus === "fulfilled") {
          //   window.print();
        }
      };
      handleDriverVisitPrint();
    }
  }, [pono]);

  let totalQty = 0;
  let totalTotalKG = 0;
  let totalGrossKG = 0;
  let totalNetKG = 0;
  let totalGrossWeight = 0;
  let totalNetWeight = 0;

  ExportSalesOrderDetailByPONO?.export_sales_order_packing_list &&
    ExportSalesOrderDetailByPONO?.export_sales_order_packing_list?.length > 0 &&
    ExportSalesOrderDetailByPONO?.export_sales_order_packing_list?.map(
      (group: any) => {
        group?.export_sales_Order_itemwise &&
          group?.export_sales_Order_itemwise?.length > 0 &&
          group?.export_sales_Order_itemwise?.map((item: any) => {
            totalQty += item?.quantity_ctn;
            totalTotalKG += item?.total_weight;
            totalGrossKG += item?.gross_kg;
            totalNetKG += item?.net_kg;
            totalGrossWeight += item?.gross_weight;
            totalNetWeight += item?.net_weight;
          });
      }
    );

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div className="container-fluid export-so-print">
        <div className="position-relative no-visible-print-btn text-end pb-2">
          {isPrintAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={() => window.print()}
            >
              Print
            </Button>
          )}
        </div>
        <table className="w-100">
          <thead>
            <tr className="bg-whitesmoke">
              <th colSpan={11} className="border-black">
                <h5 className="fw-bold text-center m-1">
                  {ExportSalesOrderDetailByPONO?.party_name}
                </h5>
              </th>
            </tr>
            <tr className="border-black bg-whitesmoke">
              <th colSpan={11}>
                <div className="d-flex gap-1 justify-content-between">
                  <div className="flex-1 d-flex justify-content-end flex-column">
                    <span>PO - {ExportSalesOrderDetailByPONO?.pono}</span>
                    <span>Date: {ExportSalesOrderDetailByPONO?.po_date}</span>
                  </div>
                  <div className="flex-1 text-end d-flex align-items-end">
                    <span>
                      Exp. Delivery Date:{" "}
                      {ExportSalesOrderDetailByPONO?.exp_delivery_date
                        ? moment(
                            ExportSalesOrderDetailByPONO?.exp_delivery_date
                          ).format("DD/MM/YYYY")
                        : ""}
                    </span>
                  </div>
                </div>
              </th>
            </tr>
            <tr className="text-center">
              <th className="border-black" rowSpan={2}>
                Sr. No.
              </th>
              <th className="border-black" rowSpan={2}>
                Item Name
              </th>
              <th className="border-black" rowSpan={2}>
                Nos Pack
              </th>
              <th className="border-black" rowSpan={2}>
                Packing
              </th>
              <th className="border-black" rowSpan={2}>
                Cartoon <br /> Bag/Nos
              </th>
              <th className="border-black" rowSpan={2}>
                Total Weight
              </th>
              <th className="border-black" rowSpan={2}>
                Sr. No.
              </th>
              <th className="border-black" colSpan={2}>
                Weight
              </th>
              <th className="border-black" colSpan={2}>
                Total Weight
              </th>
            </tr>
            <tr className="text-center">
              <th className="border-black">Gross Kg</th>
              <th className="border-black">Net Kg</th>
              <th className="border-black">Gross</th>
              <th className="border-black">Net</th>
            </tr>
          </thead>
          <tbody>
            {ExportSalesOrderDetailByPONO?.export_sales_order_packing_list &&
              ExportSalesOrderDetailByPONO?.export_sales_order_packing_list
                ?.length > 0 &&
              ExportSalesOrderDetailByPONO?.export_sales_order_packing_list?.map(
                (group: any, index: number) => {
                  return (
                    <>
                      <tr key={index}>
                        <td className="border-black"></td>
                        <td className="border-black fw-600">
                          {group?.item_group}
                        </td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                      </tr>
                      {group?.export_sales_Order_itemwise &&
                        group?.export_sales_Order_itemwise?.length > 0 &&
                        group?.export_sales_Order_itemwise?.map(
                          (item: any, subIndex: number) => {
                            return (
                              <tr key={subIndex}>
                                <td className="border-black"></td>
                                <td className="border-black">
                                  {item?.item_name}
                                </td>
                                <td className="border-black text-center">
                                  {item?.packing_size} {item?.unit_code}
                                </td>
                                <td className="border-black text-center">
                                  {item?.packing_size} {item?.unit_code} X{" "}
                                  {item?.packing_weight} {item?.packing_unit}
                                </td>
                                <td className="border-black text-center">
                                  {item?.quantity_ctn}
                                </td>
                                <td className="border-black text-end">
                                  {formatIndianNumberForQty(item?.total_weight)}
                                </td>
                                <td className="border-black text-center">
                                  {item?.sr_no}
                                </td>
                                <td className="border-black text-end">
                                  {formatIndianNumberForQty(item?.gross_kg)}
                                </td>
                                <td className="border-black text-end">
                                  {formatIndianNumberForQty(item?.net_kg)}
                                </td>
                                <td className="border-black text-end">
                                  {formatIndianNumberForQty(item?.gross_weight)}
                                </td>
                                <td className="border-black text-end">
                                  {formatIndianNumberForQty(item?.net_weight)}
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </>
                  );
                }
              )}
            <tr className="bg-whitesmoke fw-600">
              <td className="border-black"></td>
              <td className="border-black">TOTAL</td>
              <td className="border-black"></td>
              <td className="border-black"></td>
              <td className="border-black text-center">{totalQty || "0"}</td>
              <td className="border-black text-end">
                {totalTotalKG?.toFixed(3) || "0.000"}
              </td>
              <td className="border-black"></td>
              <td className="border-black text-end">
                {totalGrossKG?.toFixed(3) || "0.000"}
              </td>
              <td className="border-black text-end">
                {totalNetKG?.toFixed(3) || "0.000"}
              </td>
              <td className="border-black text-end">
                {totalGrossWeight?.toFixed(3) || "0.000"}
              </td>
              <td className="border-black text-end">
                {totalNetWeight?.toFixed(3) || "0.000"}
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <div className="row mt-4">
            <div className="col-12 text-end">
              <p className="mb-4 fw-600">HARIHAR FOODS PVT LTD</p>
            </div>
            <div className="col-12 text-end">
              <p>Authorised</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExportPackingPrint;
